export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/stylus-loader/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SchoolPosts.vue?vue&type=style&index=1&id=5ae07f0b&lang=stylus&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/SchoolPosts.vue?vue&type=style&index=1&id=5ae07f0b&lang=stylus&scoped=true
// module id = 1074
// module chunks = 12